import React from "react";

const LoadingOverlay = ({
    active,
    text = "Loading...",
    className = "",
    children,
}) => {
    return (
        <div className="relative">
            <div className={`${active ? "overlay" : "hidden"} ${className}`}>
                <div className="m-auto">
                    <div className="spinner">
                        <div className="sk-folding-cube">
                            <div className="sk-cube1 sk-cube"></div>
                            <div className="sk-cube2 sk-cube"></div>
                            <div className="sk-cube4 sk-cube"></div>
                            <div className="sk-cube3 sk-cube"></div>
                        </div>
                    </div>
                    {text}
                </div>
            </div>
            {children}
        </div>
    );
};

export default LoadingOverlay;
